var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#007bb5;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36,33.75A2.251,2.251,0,0,1,33.75,36H2.25A2.251,2.251,0,0,1,0,33.75V2.25A2.251,2.251,0,0,1,2.25,0h31.5A2.251,2.251,0,0,1,36,2.25Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.875 6.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.5,
    height: 15.75,
    transform: "translate(0 5.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.436,11c-3.14,0-3.68,1.145-3.936,2.25V11H13V26.75h4.5v-9a2.022,2.022,0,0,1,2.25-2.25A2.03,2.03,0,0,1,22,17.75v9h4.5V18.875C26.5,14.375,25.914,11,21.436,11Z",
    transform: "translate(-6.25 -5.375)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.25,
    cy: 2.25,
    r: 2.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7d2186554391d1cdd3fa93db15f40e07.svg";
export { ForwardRef as ReactComponent };